import {
    ColDef,
    ValueFormatterParams,
    ValueGetterParams,
} from 'ag-grid-community';
import { currencyFormatter } from 'ui/AgGridReact/formatters';

export const NUMBER_FILTER = {
    filter: 'agNumberColumnFilter',
    floatingFilter: true,
    suppressFloatingFilterButton: true,
    floatingFilterComponent: 'numberFloatingFilter',
    filterValueGetter: (params: ValueGetterParams) => {
        const value = params.colDef.field
            ? params.data[params.colDef.field]
            : 0;
        return parseFloat(value);
    },
};

export const TEXT_FILTER = {
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    suppressFloatingFilterButton: true,
    floatingFilterComponent: 'textFloatingFilter',
};
// TODO: create a custom date filter component

export const DATE_FILTER = {
    filter: 'agDateColumnFilter',
    floatingFilter: true,
    suppressFloatingFilterButton: true,
};

export const DEFAULT_AMOUNT_COLUMN: Partial<ColDef> = {
    ...NUMBER_FILTER,
    valueFormatter: (
        params: Partial<ValueFormatterParams>,
        forceSign?: boolean,
    ) => currencyFormatter(params, forceSign, false),
    aggFunc: 'sum',
};
